const homePage: Record<string, Record<string, string> | string> = {
    headerLinks: {
        requests: 'Мои инициативы',
        requestsNew: 'Инициативы',
        campaigns: 'Направления',
    },
};

export default homePage;
